var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "ch")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-80.0%",
    y: "-80.0%",
    width: "260.0%",
    height: "260.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_chinese_desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    id: "china",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D80027",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.796875, 4.453125)",
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.67578125 1.6328125 4.5390625 4.2890625 7.33203125 4.2890625 5.07421875 5.93359375 5.9375 8.58984375 3.67578125 6.94921875 1.4140625 8.58984375 2.28125 5.93359375 0.01953125 4.2890625 2.8125 4.2890625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.0585938 11.0351562 9.3984375 10.2226563 8.421875 10.6015625 8.98828125 9.72265625 8.328125 8.90625 9.33984375 9.17578125 9.91015625 8.296875 9.96484375 9.34375 10.9804688 9.61328125 10 9.98828125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "11.3710938 8.65234375 11.6835938 7.65234375 10.828125 7.046875 11.875 7.03125 12.1835938 6.03125 12.5234375 7.0234375 13.5703125 7.01171875 12.7304688 7.63671875 13.0664062 8.62890625 12.2109375 8.0234375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.140625 2.88671875 12.6796875 3.828125 13.4296875 4.55859375 12.3945312 4.41015625 11.9335938 5.34765625 11.7539062 4.31640625 10.7148438 4.16796875 11.6445312 3.6796875 11.4648438 2.64453125 12.2148438 3.375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.0859375 0.03515625 10.0078125 1.078125 10.9804688 1.47265625 9.9609375 1.72265625 9.88671875 2.76953125 9.3359375 1.87890625 8.31640625 2.12890625 8.9921875 1.328125 8.4375 0.44140625 9.41015625 0.8359375"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.edf17d4b.svg";
export { ForwardRef as ReactComponent };